/*!
 * This script uses heic-to (LGPL‑3.0)
 * Source: https://github.com/hoppergee/heic-to
 * Libheif WebAssembly components included under LGPL‑3.0
 */


const bgState = { offsetX: 0, offsetY: 0, scale: 1, rotation: 0 };
const overlayState = { offsetX: 0, offsetY: 0, scale: 1, rotation: 0 };

const discImg = document.getElementById("discimg");
const overlayLayer = document.getElementById("overlayLayer");
let overlayLabel = document.getElementById("overlayLabel");
const printArea = document.getElementById("printArea");
const fileInput = document.getElementById("file");
const dropzone = document.querySelector(".dropzone");

const bgZoom = document.getElementById("zoom");
const bgZoomNum = document.getElementById("zoomNum");
const bgRotate = document.getElementById("rotate");
const bgRotateNum = document.getElementById("rotateNum");

const overlayZoom = document.getElementById("overlayZoom");
const overlayZoomNum = document.getElementById("overlayZoomNum");
const overlayRotate = document.getElementById("overlayRotate");
const overlayRotateNum = document.getElementById("overlayRotateNum");

const toggleOverlay = document.getElementById("toggleOverlay");
const overlayTextInput = document.getElementById("overlayText");
const overlayFontSelect = document.getElementById("overlayFont");
const overlayColorInput = document.getElementById("overlayColor");

const exportBtn = document.getElementById("exportBtn");
const centerBtn = document.getElementById("centerBtn");
const clearBtn = document.getElementById("clearBtn");
const exportCanvas = document.getElementById("exportCanvas");

const MAX_FILE_SIZE = 10 * 1024 * 1024;

// File Upload
dropzone.addEventListener("click", () => fileInput.click());
dropzone.addEventListener("dragover", e => { e.preventDefault(); dropzone.style.background = "#eee"; });
dropzone.addEventListener("dragleave", () => dropzone.style.background = "");
dropzone.addEventListener("drop", e => {
  e.preventDefault();
  dropzone.style.background = "";
  if (e.dataTransfer.files.length) handleFileSelect(e.dataTransfer.files[0]);
});

fileInput.addEventListener("change", () => handleFileSelect(fileInput.files[0]));

// --- Main handler ---
async function handleFileSelect(file) {
  if (!file) return;

  if (file.size > MAX_FILE_SIZE) { 
    alert("File too large"); 
    return; 
  }

  // --- HEIC detection: all variations ---
  const isHeic = /\.heic$/i.test(file.name) ||
                 /\.heif$/i.test(file.name) ||
                 file.type === "image/heic" ||
                 file.type === "image/heif";

  if (isHeic) {
    try {
      const convertedBlob = await HeicTo({ blob: file, type: "image/jpeg", quality: 0.9 });

      // Handle HEVC / unsupported HEIC
      if (!convertedBlob || convertedBlob.size === 0) {
        alert("This HEIC format cannot be converted in-browser. Please use JPG or PNG.");
        return;
      }

      file = new File([convertedBlob], file.name.replace(/\.(heic|heif)$/i, ".jpg"), { type: "image/jpeg" });

    } catch (err) {
      console.error("HEIC conversion failed", err);
      alert("HEIC conversion failed. Please convert to JPG/PNG before uploading.");
      return;
    }
  }

  // --- Validation: allow images, PDFs, vectors ---
  if (!(file.type.startsWith("image/") || file.type === "application/pdf" || file.type === "image/svg+xml")) {
    alert("Invalid file type. Allowed types: PDF, images, vectors.");
    return;
  }

  // --- Load preview ---
  const reader = new FileReader();
  reader.onload = e => { discImg.src = e.target.result; };
  reader.readAsDataURL(file);
}

// Controls
bgZoom.addEventListener("input", () => { bgState.scale = bgZoom.value / 100; bgZoomNum.value = bgZoom.value; updateBackgroundTransform(); });
bgZoomNum.addEventListener("input", () => { bgState.scale = bgZoomNum.value / 100; bgZoom.value = bgZoomNum.value; updateBackgroundTransform(); });
bgRotate.addEventListener("input", () => { bgState.rotation = parseInt(bgRotate.value); bgRotateNum.value = bgRotate.value; updateBackgroundTransform(); });
bgRotateNum.addEventListener("input", () => { bgState.rotation = parseInt(bgRotateNum.value); bgRotate.value = bgRotateNum.value; updateBackgroundTransform(); });
overlayZoom.addEventListener("input", () => { overlayState.scale = overlayZoom.value / 100; overlayZoomNum.value = overlayZoom.value; updateOverlayTransform(); });
overlayZoomNum.addEventListener("input", () => { overlayState.scale = overlayZoomNum.value / 100; overlayZoom.value = overlayZoomNum.value; updateOverlayTransform(); });
overlayRotate.addEventListener("input", () => { overlayState.rotation = parseInt(overlayRotate.value); overlayRotateNum.value = overlayRotate.value; updateOverlayTransform(); });
overlayRotateNum.addEventListener("input", () => { overlayState.rotation = parseInt(overlayRotateNum.value); overlayRotate.value = overlayRotateNum.value; updateOverlayTransform(); });
overlayTextInput.addEventListener("input", () => { overlayLabel.textContent = overlayTextInput.value.slice(0, 3); });

function applyFont() {
  const newFont = overlayFontSelect.value;
  overlayLabel.style.fontFamily = `"${newFont}"`;
  overlayLabel.textContent = overlayLabel.textContent;
  overlayLabel.style.transform = "scale(1.001)";
  requestAnimationFrame(() => {
    overlayLabel.style.transform = "";
  });
  setTimeout(() => {
    if (getComputedStyle(overlayLabel).fontFamily.indexOf(newFont) === -1) {
      const newNode = overlayLabel.cloneNode(true);
      newNode.style.fontFamily = `"${newFont}"`;
      overlayLabel.parentNode.replaceChild(newNode, overlayLabel);
      overlayLabel = newNode; 
    }
  }, 50);
}


overlayFontSelect.addEventListener("input", applyFont);
overlayFontSelect.addEventListener("change", applyFont);

overlayColorInput.addEventListener("input", () => { overlayLabel.style.color = overlayColorInput.value; });

// Toggle Overlay
toggleOverlay.addEventListener("change", () => {
  if (toggleOverlay.checked) {
    overlayLayer.style.display = "flex";
    syncOverlayToImage();
  } else overlayLayer.style.display = "none";
});

function syncOverlayToImage() {
  overlayLayer.style.width = discImg.offsetWidth + "px";
  overlayLayer.style.height = discImg.offsetHeight + "px";
  overlayLayer.style.top = "50%";
  overlayLayer.style.left = "50%";
  overlayLayer.style.transform = "translate(-50%, -50%) scale(1) rotate(0deg)";
  overlayState.offsetX = overlayState.offsetY = 0;
  overlayState.scale = 1;
  overlayState.rotation = 0;
  updateOverlayTransform();
}

// Manipulate Layers
function updateBackgroundTransform() {
  discImg.style.transform = `translate(-50%,-50%) translate(${bgState.offsetX}px,${bgState.offsetY}px) scale(${bgState.scale}) rotate(${bgState.rotation}deg)`;
}
function updateOverlayTransform() {
  overlayLayer.style.transform = `translate(-50%,-50%) translate(${overlayState.offsetX}px,${overlayState.offsetY}px) scale(${overlayState.scale}) rotate(${overlayState.rotation}deg)`;
}

// Shared Helpers
function updateTransform(el, state, isOverlay) {
  if (isOverlay) {
    overlayLayer.style.transform = `translate(-50%,-50%) translate(${state.offsetX}px,${state.offsetY}px) scale(${state.scale}) rotate(${state.rotation}deg)`;
  } else {
    discImg.style.transform = `translate(-50%,-50%) translate(${state.offsetX}px,${state.offsetY}px) scale(${state.scale}) rotate(${state.rotation}deg)`;
  }
}


// Drag + pinch handler
function addInteraction(el, state, isOverlay = false) {
  let isDragging = false;
  let startX = 0, startY = 0;

  // For pinch zoom
  let initialDistance = 0;
  let initialScale = 1;

  // Mouse drag
  el.addEventListener("mousedown", e => {
    isDragging = true;
    startX = e.clientX - state.offsetX;
    startY = e.clientY - state.offsetY;
  });
  window.addEventListener("mousemove", e => {
    if (!isDragging) return;
    state.offsetX = e.clientX - startX;
    state.offsetY = e.clientY - startY;
    updateTransform(el, state, isOverlay);
  });
  window.addEventListener("mouseup", () => { isDragging = false; });

  // Touch drag + pinch
  el.addEventListener("touchstart", e => {
    if (e.touches.length === 1) {
      isDragging = true;
      startX = e.touches[0].clientX - state.offsetX;
      startY = e.touches[0].clientY - state.offsetY;
    } else if (e.touches.length === 2) {
      isDragging = false;
      initialDistance = getDistance(e.touches[0], e.touches[1]);
      initialScale = state.scale;
    }
  });

  el.addEventListener("touchmove", e => {
    if (e.touches.length === 1 && isDragging) {
      state.offsetX = e.touches[0].clientX - startX;
      state.offsetY = e.touches[0].clientY - startY;
      updateTransform(el, state, isOverlay);
    } else if (e.touches.length === 2) {
      const newDist = getDistance(e.touches[0], e.touches[1]);
      const scaleChange = newDist / initialDistance;
      state.scale = Math.max(0.1, Math.min(initialScale * scaleChange, 10)); // limit zoom
      updateTransform(el, state, isOverlay);
    }
  });

  el.addEventListener("touchend", e => {
    if (e.touches.length < 2) {
      initialDistance = 0;
    }
    if (e.touches.length === 0) {
      isDragging = false;
    }
  });
}

function getDistance(touch1, touch2) {
  const dx = touch2.clientX - touch1.clientX;
  const dy = touch2.clientY - touch1.clientY;
  return Math.sqrt(dx * dx + dy * dy);
}

addInteraction(discImg, bgState, false);
addInteraction(overlayLayer, overlayState, true);

// Buttons
centerBtn.addEventListener("click", () => {
  if (toggleOverlay.checked) {
    overlayState.offsetX = 0;
    overlayState.offsetY = 0;
    updateOverlayTransform();
  } else {
    bgState.offsetX = 0;
    bgState.offsetY = 0;
    updateBackgroundTransform();
  }
});
clearBtn.addEventListener("click", () => {
  discImg.src = "https://cdn.shopify.com/s/files/1/0340/2849/files/UploadYourArt.png?v=1757368532";
  Object.assign(bgState, { offsetX: 0, offsetY: 0, scale: 1, rotation: 0 });
  bgZoom.value = bgZoomNum.value = 100;
  bgRotate.value = bgRotateNum.value = 0;
  updateBackgroundTransform();
  overlayLayer.style.display = "none";
});

// Export
exportBtn.addEventListener("click", async () => {

  const prevPrintTransform = printArea.style.transform;
  printArea.style.transform = "none"; 

  const capturedCanvas = await html2canvas(printArea, {
    backgroundColor: null,
    scale: 4,
    useCORS: true,
  });

  printArea.style.transform = prevPrintTransform;

  const exportCanvas = document.getElementById("exportCanvas");
  exportCanvas.width = exportCanvas.height = 1611;
  const ctx = exportCanvas.getContext("2d");
  ctx.clearRect(0, 0, exportCanvas.width, exportCanvas.height);

  const scale = Math.min(exportCanvas.width / capturedCanvas.width, exportCanvas.height / capturedCanvas.height);
  const drawWidth = capturedCanvas.width * scale;
  const drawHeight = capturedCanvas.height * scale;
const offsetX = Math.round((exportCanvas.width - drawWidth) / 2);
const offsetY = Math.round((exportCanvas.height - drawHeight) / 2);

  ctx.drawImage(capturedCanvas, 0, 0, capturedCanvas.width, capturedCanvas.height, offsetX, offsetY, drawWidth, drawHeight);

  const link = document.createElement("a");
  link.download = "disc-art.png";
  link.href = exportCanvas.toDataURL("image/png");
  link.click();
});